import { Injectable } from "@angular/core";
import { PericiaController } from "app/controllers/mob/pericia.controller";
import { PericiaDTO, PericiaListDTO } from "app/model/dtos/mob/pericia.dto";
import { LoaderService } from "../loader.service";
import { PericiaSearch } from "./pericia.search";

@Injectable() 
export class PericiaService{
    constructor(
        private _periciaController: PericiaController,
        private _loaderService: LoaderService
    ){}

    async find(periciaSearch: PericiaSearch):Promise<PericiaListDTO>{
        this._loaderService.show();
        return await this._periciaController.find(periciaSearch && periciaSearch.getFilters() || null).finally(() => this._loaderService.hide());
    }
    
    async update(periciaDto: PericiaDTO[]):Promise<PericiaDTO[]>{
        this._loaderService.show();
        return await this._periciaController.update(periciaDto).finally(() => this._loaderService.hide());
    }
}